// extracted by mini-css-extract-plugin
export default {"SummaryFocusManager":"xdVeNYhJyNHhTKu5ddjE"};